module.exports = __webpack_public_path__ + "assets/media/level2-user-icon.2527a192.png";